// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1XW4k","title":"Info_title__3HtF6","selects":"Info_selects__2Fpc8","requiredAsterisk":"Info_requiredAsterisk__2WrVM"};